import {useFlag, useVariant} from '@unleash/proxy-client-react';

export const useMenuVisibility = (flagKey) => {
  const flag = useFlag(flagKey);
  const variant = useVariant(flagKey);

  let visibility = {};
  const rawVisibility = variant?.payload?.value;

  if (typeof rawVisibility === 'string') {
    try {
      visibility = JSON.parse(rawVisibility) || {};
    } catch (e) {
      visibility = {};
    }
  }
  const isItemVisible = (itemKey, defaultValue = true) => {
    const value = visibility[itemKey];
    if (typeof value === 'boolean') {
      return value;
    }
    return defaultValue;
  };

  return {flag, isItemVisible};
};
